import { toastError, TOAST_MESSAGE } from "../constants";

export const customerFeedbackValidation = (props: any): any => {
  let formErrors: any = {};
  let formValid: any = true;

  const { rating } = props;

  if (rating < 1) {
    formValid = false;
    formErrors["rating"] = toastError(
      TOAST_MESSAGE.CUSTOMER_FEEDBACK_RATING_MESSAGE
    );
  }

  return { formValid, formErrors };
};
